import React from 'react';
import { 
  Paper, 
  Box, 
  Typography, 
  Avatar, 
  Rating, 
  alpha, 
  useTheme 
} from '@mui/material';
import { Person } from '@mui/icons-material';
import { motion } from 'framer-motion';

const ReviewCard = ({ user, rating, text, date }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <motion.div
      whileHover={{ y: -5 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 3,
          borderRadius: '24px', 
          height: '100%',
          bgcolor: isDarkMode ? alpha('#1A1A1A', 0.6) : '#FFFFFF',
          backdropFilter: "blur(10px)",
          border: '1px solid',
          borderColor: isDarkMode ? alpha('#D4AF37', 0.1) : '#F1F5F9',
          boxShadow: isDarkMode ? 'none' : '0 10px 30px rgba(0,0,0,0.03)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Avatar sx={{ 
            width: 48, height: 48,
            bgcolor: alpha('#D4AF37', 0.1), 
            color: '#D4AF37',
            border: `1px solid ${alpha('#D4AF37', 0.3)}`
          }}>
            <Person />
          </Avatar>
          <Box>
            <Typography variant="subtitle1" fontWeight={900} sx={{ lineHeight: 1.2, color: "text.primary" }}>
              {user}
            </Typography>
            {date && (
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                {date}
              </Typography>
            )}
          </Box>
        </Box>

        <Rating 
          value={Number(rating)} 
          readOnly 
          size="small" 
          precision={0.5} 
          sx={{ mb: 2, color: '#D4AF37' }} 
        />

        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            lineHeight: 1.7,
            fontWeight: 500,
            display: '-webkit-box',
            WebkitLineClamp: 5,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {text}
        </Typography>
      </Paper>
    </motion.div>
  );
};

export default ReviewCard;
